import PhoneInput from "react-phone-input-2";
import countries from '../../../countries.json';
import React from "react";

export const PhoneInputField = ({
  isRequired,
  title,
  value,
  onChange,
  placeholder,
  country,
  disabled,
}) => {
  const getCountryCode = () => {
    const _country =  countries.find((c) => c.name.toLowerCase() === country.toLowerCase());
    return _country ? _country.code2.toLowerCase() : 'us'
  }

  return (
    <div>
      <div className="font-semibold uppercase text-[12px] text-gray-600">
        {title} <span className="text-red-500">{isRequired ? "*" : null}</span>
      </div>
      <PhoneInput
        country={getCountryCode()}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        inputProps={{
          required: isRequired
        }}
        inputStyle={{
          width: "100%",
          borderRadius: "4px",
          paddingTop: "8px",
          paddingBottom: "8px",
          fontSize: "0.875rem",
          lineHeight: "1.25rem",
          borderColor: "#d1d5db",
        }}
        inputClass="disabled:bg-gray-100"
      />
    </div>
  );
};
